<template>
  <div class="loading isAlbum" :class="fromAlbum ? 'is-fromAlbum' : ''">
    <div class="content">
      <div class="logo">
        <img v-show="canShowLogo" :src="loadingPic" alt="" />
      </div>
      <img :src="uploading" alt="" class="pageTurn" />
      <p>{{ shareTitle }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { isPureNum } from '@/utils'
export default {
  name: 'loading',
  data() {
    return {
      uploading: require('@imgs/pageTurning.gif'),
      loadDefault: require('@imgs/loading_logo.png'),
      fromAlbum: false,
      canShowLogo: false
    }
  },
  computed: {
    shareTitle() {
      return this.$store.state.config.bookObj.shareTitle
    },
    getQueryId() {
      return isPureNum(this.$route.query.id)
    },
    isStaticBook() {
      return this.$store.state.common.isStaticBook
    },
    loadingPic() {
      // 后端默认为'logo.png或空'
      let logo = this.$store.state.config.bookObj.loadPic
      if (logo === undefined || logo === 'logo.png') {
        logo = this.loadDefault
      }
      return logo
    },
    ...mapState('config', ['bookObj'])
  },
  watch: {
    bookObj() {
      // 等待bookObj更新完毕后再展示logo
      this.canShowLogo = true
    }
  },
  created() {
    if (this.isStaticBook) {
      this.fromAlbum = true
      return
    }
    if ((this.$route.query.form && (this.$route.query.shelfId || this.$route.query.libId)) || this.$store.state.book.isMobile) {
      this.fromAlbum = true
    }
  }
}
</script>

<style scoped lang="scss">
.loading {
  position: absolute;
  top: 80px;
  left: 0;
  z-index: 100000;
  width: 100vw;
  // height: calc(100vh - 80px);
  height: 100vh;
  // background: #cecece;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  .content {
    // text-align: center;
    // width: 80px;
    .pageTurn {
      width: 80px;
      display: block;
      margin: 20px auto;
    }
    .logo {
      // width: 300px;
      // width: 80px;
      height: 100px;
      // border: 1px dashed #eee;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    p {
      color: #3a3a3a;
      font-size: 18px;
      text-align: center;
    }
  }
}
.isAlbum.is-fromAlbum {
  top: 0 !important;
}
</style>
